// Bootstrap with a guard so any load-time failure (missing env var,
// module init error) renders a readable message instead of a blank page.

function showFatal(message: string) {
  const root = document.getElementById('root');
  if (!root) return;
  root.innerHTML = `
    <div style="max-width:640px;margin:64px auto;padding:24px;font:14px/1.5 -apple-system,sans-serif;color:#e6e9ee;background:#171b21;border:1px solid #4a2b2b;border-radius:10px">
      <h2 style="margin:0 0 8px;color:#f1a8a3">App failed to start</h2>
      <pre style="white-space:pre-wrap;color:#9aa4b2;margin:0">${message.replace(/[<>&]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]!))}</pre>
      <p style="color:#9aa4b2;margin:16px 0 0">If this mentions a missing <code>VITE_*</code> var, check <code>.env.development</code> and restart <code>npm run dev</code>.</p>
    </div>`;
}

window.addEventListener('error', (e) => showFatal(String(e.error?.stack || e.message)));
window.addEventListener('unhandledrejection', (e) =>
  showFatal(String(e.reason?.stack || e.reason)),
);

async function bootstrap() {
  try {
    const [
      React,
      { default: ReactDOM },
      { BrowserRouter },
      { QueryClient, QueryClientProvider },
      { AuthProvider },
      { App },
    ] = await Promise.all([
      import('react'),
      import('react-dom/client'),
      import('react-router-dom'),
      import('@tanstack/react-query'),
      import('./auth/AuthContext'),
      import('./App'),
    ]);
    await import('./styles.css');

    const queryClient = new QueryClient({
      defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
    });

    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </React.StrictMode>,
    );
  } catch (err) {
    showFatal(err instanceof Error ? (err.stack ?? err.message) : String(err));
  }
}

void bootstrap();
